import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  getNaverWcsAccountId,
  trackNaverPageView,
} from '../utils/naverWcs'

/** SPA에서 라우트마다 네이버 WCS PV(wcs_do) 전송 */
export function useNaverWcsPageView() {
  const location = useLocation()
  const accountId = getNaverWcsAccountId()

  useEffect(() => {
    if (!accountId) return
    void trackNaverPageView()
  }, [location.pathname, location.search, accountId])
}
